import clsx from "clsx";
import { Grid, Radio, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../View";
import { RouteLabel } from "../../Layers/RouteLabelLayer/RouteLabel";
import { palette } from "../../../theme/palette";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  option: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  optionMessage: {
    flex: 1,
  },
  labelContainer: {
    width: "86px",
    display: "flex",
    justifyContent: "center",
  },
  labelGrid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
    minHeight: "30px",
  },
  spacing: {
    padding: "2px",
  },
});

export const RouteEditOptionsModalContent = ({
  message,
  options,
  selectedOption,
  onOptionChange,
}) => {
  const styles = useStyles();
  const renderOption = (option, index) => {
    const { labelRouteCodes } = option;
    return (
      <Grid container key={index} className={styles.option}>
        <Radio
          checked={selectedOption === option}
          onChange={() => onOptionChange(option)}
          value={option}
          inputProps={{
            "aria-label": option.message,
          }}
        />
        <Typography className={styles.optionMessage}>
          {option.message}
        </Typography>
        <View className={styles.labelContainer}>
          <View>
            <Grid container className={styles.labelGrid}>
              {labelRouteCodes.length > 6 ? (
                <Grid
                  item
                  container
                  xs
                  className={clsx(styles.spacing)}
                  direction={"row"}
                >
                  <RouteLabel routeCode={"M"} />
                </Grid>
              ) : (
                labelRouteCodes.map((routeCode, index) => (
                  <Grid
                    key={index}
                    item
                    container
                    xs={
                      labelRouteCodes.length >= 3
                        ? 4
                        : 12 / labelRouteCodes.length
                    }
                    className={clsx(styles.spacing)}
                    direction={"row"}
                  >
                    <RouteLabel routeCode={routeCode} />
                  </Grid>
                ))
              )}
            </Grid>
          </View>
        </View>
      </Grid>
    );
  };

  return (
    <View className={styles.container}>
      <Typography>{message}</Typography>
      {options.map(renderOption)}
    </View>
  );
};
